/* tslint:disable */

import {Injectable, Injector} from '@angular/core';
import {environment} from "../../../../environments/environment";
import {
    CoronalView,
    DorsalView,
    MovieView,
    SagittalView,
    ScaleBar,
    SelectedPosition,
    TwoDView,
    Zoom
} from "./twoDViewModels";
import {HttpService} from "../../../http.service";
import {TwoDDrawingService} from "./two-ddrawing.service";
import {
    OrthogonalViewsLayout,
    SingleViewsLayout,
    SplitViewsLayout,
    TwoDViewLayout
} from "./two-dview-layout/layoutModels";
import {NgxSpinnerService} from "ngx-spinner";
import {BehaviorSubject} from "rxjs";
import {MarkersService} from "../../markers/markers.service";
import {NeuronsGroup, Node} from "../../neurons/neuronsModels";
import {RectangularROI, EllipsoidROI} from "../../ROIs/ShapeROIsModel";
import {SharedService} from "../../../shared.service";
import {AlertService} from "../../../alert.service";
import {LayoutEventsService} from "./two-dview-layout/layout-events.service";
import {NeuronsService} from "../../neurons/neurons.service";
import {THREE} from "@angular/cdk/keycodes";

declare function drawNode(nodePosition, color, isFill, inSelectedPosition, radius, isSoma, canvas): any;

declare function drawLine(startPoint, endPoint, color, canvas, opacity): any;

declare function drawEllipse(position, radiusX, radiusY, color, isFill, canvas, opacity): any;

// declare function drawRectangular(startPosition, dimensions, color, canvas, opacity): any;
declare function drawRectangular(startPosition, endPosition, color, canvas, opacity): any;

declare function drawAutoGeneratedRectangular(topLeft, dimensions, color, canvas, opacity): any;

@Injectable({
    providedIn: 'root'
})
export class TwoDService {
    twoDLayoutContainer;
    imagesInfo;

    chosenView = 'Orthogonal views';
    chosenViewLabel = {};
    currentChosenViewKey = 0;

    views: {
        dorsal: DorsalView,
        sagittal: SagittalView,
        coronal: CoronalView,
        movieX: MovieView,
        movieY: MovieView,
    };

    urlLoadImagesInfo = environment.apiURL + 'load_2d_views_images_info';

    neuronsGroups: NeuronsGroup[] = [];
    rois: EllipsoidROI[] = [];
    rectangularRois = [];

    sceneItems = {
        images: {
            split: [], //Markers and Fish
            nonSplit: [] // Brain and Regions and Masks
        },
        neuronsGroups: this.neuronsGroups,
        rois: this.rois,
        rectangularRois: this.rectangularRois
    }

    markersLookUpTable = {}

    neuronsImage = null;
    activeView: TwoDView;
    subjectIsLayoutActivated = new BehaviorSubject(false);

    layouts: {
        orthogonal: OrthogonalViewsLayout,
        single: SingleViewsLayout,
        split: SplitViewsLayout
    } =
        {
            orthogonal: null,
            single: null,
            split: null
        };

    activeLayout: TwoDViewLayout;

    // Don't draw, update, or resize until all the layouts and views are initialized
    locks = {
        isViewsInit: false,
        initializedLayouts: 0
    }

    isReadyToUpdate = true;

    constructor(private httpService: HttpService,
                private drawingService: TwoDDrawingService,
                private injector: Injector,
                private sharedService: SharedService,
                private spinner: NgxSpinnerService,
                private alertService: AlertService) {
        this.loadImagesInfo();
        this.initChosenViewLabels();
        this.subjectIsLayoutActivated.subscribe((isLayoutActivated) => {
            if (isLayoutActivated) {
                this.updateScene().then(r => spinner.hide());
            }
        })

    }

    initChosenViewLabels() {
        this.chosenViewLabel = {
            0: 'Orthogonal views',
            1: 'Horizontal as single layout',
            2: 'Sagittal as single layout',
            3: 'Coronal as single layout',
            4: 'MoviesX as single layout',
            5: 'MovieY as a single layout',
            6: 'Horizontal as a split layout',
            7: 'Sagittal as split layout',
            8: 'Coronal as split layout',
            9: 'MovieX as split layout',
            10: 'MovieY as split layout'
        }
    }

    initViews() {
        this.views = {
            dorsal: new DorsalView(this.imagesInfo.orthogonal_views.dorsal),
            sagittal: new SagittalView(this.imagesInfo.orthogonal_views.sagittal),
            coronal: new CoronalView(this.imagesInfo.orthogonal_views.coronal),
            movieX: new MovieView('x', 'x', this.imagesInfo.movie_views.x),
            movieY: new MovieView('y', 'y', this.imagesInfo.movie_views.y),
        }
        this.locks.isViewsInit = true;
        this.initScene();
    }

    initScene() {
        if (this.locks.isViewsInit && this.locks.initializedLayouts === 3) {
            this.activeView = this.views.dorsal;
            SelectedPosition.initializeOrthogonalViews();
            this.activateLayout(this.layouts.orthogonal);

            // this.activeView = this.views.movieY;
            // SelectedPosition.initializeMovieView(this.activeView);
            // this.activateLayout(this.layouts.single);

            Zoom.init(this.twoDLayoutContainer);
        }
    }

    loadImagesInfo() {
        this.httpService.postRequest(this.urlLoadImagesInfo, {}).subscribe((response) => {
            this.imagesInfo = response['data'];
            this.initViews();
        });
    }

    isMovieView() {
        return (this.activeView === this.views.movieX || this.activeView === this.views.movieY);
    }

    playMovieViewButtonClick() {
        // this.movieViewOptions.currentFrameIndex = SelectedPosition.coordinates[this.activeLayout.activeView.axis];
        // this.movieViewOptions.isPlay = !this.movieViewOptions.isPlay;
        // if (this.movieViewOptions.isPlay) {
        //     this.movieViewOptions.movieViewVideoIntervalID = setInterval(() => this.drawNextFrame(this.activeLayout), this.movieViewOptions.movieViewVideoSpeed);
        // } else {
        //     clearInterval(this.movieViewOptions.movieViewVideoIntervalID);
        // }
    };

    activateLayout(activeLayout = null) {
        if (activeLayout) {
            this.activeLayout = activeLayout;
        }

        setTimeout(() => {
            if (this.activeLayout === this.layouts.orthogonal) {
                this.activeLayout.resize(
                    [
                        this.views.dorsal.imageInfo.ratio,
                        this.views.sagittal.imageInfo.ratio,
                        this.views.coronal.imageInfo.ratio],
                    [
                        this.views.dorsal.imageInfo.size,
                        this.views.sagittal.imageInfo.size,
                        this.views.coronal.imageInfo.size
                    ]);
            } else {
                if (this.activeLayout === this.layouts.split) {
                    let markerService = this.injector.get<MarkersService>(MarkersService);
                    if (this.sceneItems.images.split.length > 6) {

                        let index = 6;
                        while (index <= markerService.markersData.selectedMarkersList.length) {
                            let currentSelectedMarker = markerService.markersData.selectedMarkersList[6];
                            currentSelectedMarker.selected = false;
                            currentSelectedMarker.show = false;
                            markerService.markersData.dictionary[currentSelectedMarker.id].selected = false;
                            markerService.markersData.dictionary[currentSelectedMarker.id].show = false;
                            markerService.markersData.selectedMarkersList.splice(6, 1);

                            this.removeMarkerFrom2DScene(this.sceneItems.images.split[currentSelectedMarker], false);
                            index++;
                        }
                    }
                    this.layouts.split.updateLayout(this.activeView.name, this.sceneItems.images.split.length);
                }
                this.activeLayout.resize(
                    [this.activeView.imageInfo.ratio],
                    [this.activeView.imageInfo.size]);
            }

            // The subscribed code is in the constructor
            this.subjectIsLayoutActivated.next(true);
        }, 100);
    }

    addImageTo2DScene(isSplit, imgDrawingInfo, isUpdate = true) {
        // if (isSplit) {
        //     if ((this.activeLayout === this.layouts.split && this.sceneItems.images.split.length < 6) ||
        //         (this.activeLayout !== this.layouts.split)) {
        //         this.sceneItems.images.split.push(imgDrawingInfo);
        //     }
        //     if (this.activeLayout === this.layouts.split) {
        //         this.activateLayout(this.activeLayout);
        //         if (this.sceneItems.images.split.length === 6) {
        //             alert("Split view is only possible for up to 6 Markers. Please remove one of your current selected Markers from the right side menu.");
        //         }
        //     }
        // } else {
        //     this.sceneItems.images.nonSplit.push(imgDrawingInfo);
        // }

        if (isUpdate) {
            this.updateScene().then(r => this.spinner.hide());
        }
    }

    removeImageFrom2DScene(isSplit, imgDrawingInfo, isUpdate = true) {
        // let selectedImagesArray = this.sceneItems.images.split;
        // if (isSplit === false) {
        //     selectedImagesArray = this.sceneItems.images.nonSplit;
        // }
        //
        // let imageIndex = selectedImagesArray.indexOf(imgDrawingInfo);
        // selectedImagesArray.splice(imageIndex, 1);
        //
        // if (this.activeLayout === this.layouts.split) {
        //     this.activateLayout(this.activeLayout);
        // }

        if (isUpdate) {
            this.updateScene().then(r => this.spinner.hide());
        }
    }

    addNonSplitImageTo2DScene(nonSplitImageDrawingInfo, isUpdate = true) {
        this.sceneItems.images.nonSplit.push(nonSplitImageDrawingInfo);
        if (isUpdate) {
            this.updateScene().then(r => this.spinner.hide());
        }
    }

    removeNonSplitImageFrom2DScene(nonSplitImageDrawingInfo, isUpdate = true) {
        let imageIndex = this.sceneItems.images.nonSplit.indexOf(nonSplitImageDrawingInfo);
        this.sceneItems.images.nonSplit.splice(imageIndex, 1);

        if (isUpdate) {
            this.updateScene().then(r => this.spinner.hide());
        }
    }

    // Each marker is an array to add its average and its fish

    updateMarkersLookUpTable(deletedMarkerID) {
        let deletedMarkerIndex = this.markersLookUpTable[deletedMarkerID];
        for (let markerID in this.markersLookUpTable) {
            if (this.markersLookUpTable[markerID] > deletedMarkerIndex) {
                this.markersLookUpTable[markerID] -= 1;
            }
        }
    }

    addMarkerTo2DScene(markerID: number, markerAverageImageDrawingInfo, isUpdate = true) {
        if ((this.activeLayout === this.layouts.split && this.sceneItems.images.split.length < 6) ||
            (this.activeLayout !== this.layouts.split)) {
            this.sceneItems.images.split.push([markerAverageImageDrawingInfo]);
            this.markersLookUpTable[markerID] = this.sceneItems.images.split.length - 1;
        }
        if (this.activeLayout === this.layouts.split) {
            this.activateLayout(this.activeLayout);
            if (this.sceneItems.images.split.length === 6) {
                this.alertService.showWarningMsg('Split view is only possible for up to 6 Markers. Please remove one of your current selected Markers from the right side menu.');
            }
        }

        if (isUpdate) {
            this.updateScene().then(r => this.spinner.hide());
        }
    }

    removeMarkerFrom2DScene(markerID: number, markerAverageImageDrawingInfo, isUpdate = true) {
        this.sceneItems.images.split.splice(this.markersLookUpTable[markerID], 1);
        this.updateMarkersLookUpTable(markerID);
        delete this.markersLookUpTable[markerID];

        if (isUpdate) {
            if (this.activeLayout === this.layouts.split) {
                this.activateLayout(this.activeLayout);
            } else {
                this.updateScene().then(r => this.spinner.hide());
            }

        }
    }

    addMarkerAverageTo2DScene(markerID: number, markerAverageImageDrawingInfo, isUpdate = true) {
        this.sceneItems.images.split[this.markersLookUpTable[markerID]].splice(0, 0, markerAverageImageDrawingInfo);

        if (isUpdate) {
            this.updateScene().then(r => this.spinner.hide());
        }
    }

    removeMarkerAverageImageFrom2DScene(markerID: number, isUpdate = true) {
        this.sceneItems.images.split[this.markersLookUpTable[markerID]].splice(0, 1);

        if (isUpdate) {
            this.updateScene().then(r => this.spinner.hide());
        }
    }

    addFishImageTo2DScene(markerID: number, fishImageDrawingInfo, isUpdate = true) {
        this.sceneItems.images.split[this.markersLookUpTable[markerID]].push(fishImageDrawingInfo);

        if (isUpdate) {
            this.updateScene().then(r => this.spinner.hide());
        }
    }

    removeFishImageFrom2DScene(fishImageDrawingInfo, markerID: number, isUpdate = true) {
        let fishArray = this.sceneItems.images.split[this.markersLookUpTable[markerID]];
        let imageIndex = fishArray.indexOf(fishImageDrawingInfo);
        fishArray.splice(imageIndex, 1);

        if (isUpdate) {
            this.updateScene().then(r => this.spinner.hide());
        }
    }

    //region Neurons

    addNeuronsGroupTo2DScene(neuronsGroup: NeuronsGroup, isUpdate = true) {
        if (this.sceneItems.neuronsGroups.indexOf(neuronsGroup) == -1) {
            this.sceneItems.neuronsGroups.push(neuronsGroup);
        }

        if (isUpdate) {
            this.updateScene();
            this.spinner.hide();
        }
    }

    removeNeuronsGroupFrom2DScene(neuronsGroup: NeuronsGroup, isUpdate = true) {
        let neuronGroupIndex = this.sceneItems.neuronsGroups.indexOf(neuronsGroup);
        this.sceneItems.neuronsGroups.splice(neuronGroupIndex, 1);

        if (isUpdate) {
            this.updateScene();
        }
    }

    initNodePosition2D(nodeIndex, neuron, viewname) {
        // Initialize the 2D position when nodeIndex is still 0 which indicate soma.
        if (nodeIndex == 0) {
            neuron.activeFile.data.nodes[viewname] = {'x': [], 'y': [], 'z': []}
        }
    }

    setNodePosition2D(neuron, viewname, nodePosition2D) {
        neuron.activeFile.data.nodes[viewname]['x'].push(nodePosition2D.x)
        neuron.activeFile.data.nodes[viewname]['y'].push(nodePosition2D.y)
        neuron.activeFile.data.nodes[viewname]['z'].push(nodePosition2D.z)
    }

    async updateNeuronsCoordinates() {
        for (let i = 0; i < this.sceneItems.neuronsGroups.length; i++) {
            let neuronsGroup = this.sceneItems.neuronsGroups[i];
            for (let j = 0; j < neuronsGroup.neuronsData.neuronsIDs.length; j++) {
                let neuronID = neuronsGroup.neuronsData.neuronsIDs[j];
                let neuron = neuronsGroup.neuronsData.neurons[neuronID];

                let shouldCalculate = false;
                if (this.activeLayout === this.layouts.orthogonal) {
                    shouldCalculate = (!neuron.is2DDataCalculated(this.views.dorsal.name) ||
                        !neuron.is2DDataCalculated(this.views.sagittal.name) ||
                        !neuron.is2DDataCalculated(this.views.coronal.name))
                } else if (this.activeLayout === this.layouts.single ||
                    this.activeLayout === this.layouts.split) {
                    shouldCalculate = !neuron.is2DDataCalculated(this.activeView.name);
                }

                if (shouldCalculate) {

                    // Just loop through any array (x,y,z or parent) we only need the length
                    for (let nodeIndex = 0; nodeIndex < neuron.activeFile.data.nodes._3d.x.length; nodeIndex++) {
                        // actual node position parsed from swc file
                        let nodePosition3D = {
                            'x': neuron.activeFile.data.nodes._3d.x[nodeIndex],
                            'y': neuron.activeFile.data.nodes._3d.y[nodeIndex],
                            'z': neuron.activeFile.data.nodes._3d.z[nodeIndex]
                        }

                        if (this.activeLayout === this.layouts.orthogonal) {
                            this.initNodePosition2D(nodeIndex, neuron, this.views.dorsal.name);
                            let nodePositionDorsal = this.views.dorsal.convert3DPositionTo2DPosition(nodePosition3D, this.layouts.orthogonal.dorsalImageToCanvasRatio,
                                this.layouts.orthogonal.dorsalCanvas.height);
                            this.setNodePosition2D(neuron, this.views.dorsal.name, nodePositionDorsal);

                            this.initNodePosition2D(nodeIndex, neuron, this.views.sagittal.name);
                            let nodePositionSagittal = this.views.sagittal.convert3DPositionTo2DPosition(nodePosition3D, this.layouts.orthogonal.sagittalImageToCanvasRatio,
                                this.layouts.orthogonal.sagittalCanvas.height);
                            this.setNodePosition2D(neuron, this.views.sagittal.name, nodePositionSagittal);

                            this.initNodePosition2D(nodeIndex, neuron, this.views.coronal.name);
                            let nodePositionCoronal = this.views.coronal.convert3DPositionTo2DPosition(nodePosition3D, this.layouts.orthogonal.coronalImageToCanvasRatio,
                                this.layouts.orthogonal.coronalCanvas.height);
                            this.setNodePosition2D(neuron, this.views.coronal.name, nodePositionCoronal);

                        } else if (this.activeLayout === this.layouts.single) {
                            this.initNodePosition2D(nodeIndex, neuron, this.activeView.name);
                            let nodePosition = this.activeView.convert3DPositionTo2DPosition(nodePosition3D, this.layouts.single.imageToCanvasRatio,
                                this.layouts.single.canvas.height);
                            this.setNodePosition2D(neuron, this.activeView.name, nodePosition);

                        } else if (this.activeLayout === this.layouts.split) {
                            this.initNodePosition2D(nodeIndex, neuron, this.activeView.name);
                            let nodePosition = this.activeView.convert3DPositionTo2DPosition(nodePosition3D, this.layouts.split.imageToCanvasRatio,
                                this.layouts.split.htmlElements.canvases[0].height);
                            this.setNodePosition2D(neuron, this.activeView.name, nodePosition);
                        }
                    }
                }
            }
        }
    }

    // drawNeuronsGroups2(neuronsGroup: NeuronsGroup, viewName: string, canvas) {
    //     for (let i = 0; i < neuronsGroup.neuronsData.neuronsIDs.length; i++) {
    //         let neuronID = neuronsGroup.neuronsData.neuronsIDs[i];
    //         let neuron = neuronsGroup.neuronsData.neurons[neuronID];
    //
    //         if (neuron.selected) {
    //             let neuronData = neuron.activeFile.data;
    //             let color = neuron.visualizationOptions.color.hex;
    //
    //             let somaPosition = neuron.getSoma().position[viewName];
    //
    //             if (somaPosition === null) {
    //                 return false;
    //             }
    //
    //             drawNode(somaPosition, color, true, somaPosition.z === SelectedPosition.coordinates[this.views[viewName].axis], 6, true, canvas);
    //
    //             if (neuronsGroup.visualizationOptions.isOnlySoma === false) {
    //                 for (let i = 0; i < neuronData.links.length; i += 1) {
    //                     let startPosition = neuronData.links[i].parent.position[viewName];
    //                     let endPosition = neuronData.links[i].child.position[viewName];
    //
    //                     drawLine(startPosition, endPosition, color, canvas, 1);
    //
    //                     if ((startPosition.layer === SelectedPosition.coordinates[this.views[viewName].axis])) {
    //                         drawNode(startPosition, color, false, true, 3, false, canvas);
    //                     }
    //                 }
    //             }
    //         }
    //
    //     }
    // }

    createLinkList(nodes, viewName, index) {
        // Recreate the Links array
        let parentValue = nodes.parent[index];

        // Parent ID needs to be adjusted for zero-based array
        // Since SWC parent IDs start at 1, but JavaScript array indices start at 0, you need to subtract 1 from the parent ID to find the correct position in the array.
        let parentIndex = parentValue - 1; // Convert 1-based ID to 0-based index

        let endPosition = {
            x: nodes[viewName].x[index],
            y: nodes[viewName].y[index],
            z: nodes[viewName].z[index],
        };

        let startPosition = {
            x: nodes[viewName].x[parentIndex],
            y: nodes[viewName].y[parentIndex],
            z: nodes[viewName].z[parentIndex],
        };
        return {startPosition, endPosition};
    }


    drawNeuronsGroup(neuronsGroup: NeuronsGroup, viewName: string, canvas) {
        // console.log("drawNeuronsGroup");
        for (let i = 0; i < neuronsGroup.neuronsData.neuronsIDs.length; i++) {
            let neuronID = neuronsGroup.neuronsData.neuronsIDs[i];
            let neuron = neuronsGroup.neuronsData.neurons[neuronID];

            if (neuron.selected) {
                let neuronData = neuron.activeFile.data;
                let color = neuron.visualizationOptions.color.hex;

                // let somaPosition = neuron.getSoma().position[viewName];
                let somaPosition = neuron.getSoma2DPosition(viewName);

                if (somaPosition === null) {
                    return false;
                }

                drawNode(somaPosition, color, true, somaPosition.z === SelectedPosition.coordinates[this.views[viewName].axis], 6, true, canvas);

                if (neuronsGroup.visualizationOptions.isOnlySoma === false) {
                    for (let i = 0; i < neuronData.nodes.parent.length; i += 1) {

                        // Skip root node (-1 has no parent)
                        if (neuronData.nodes.parent[i] === -1) {
                            continue;
                        }

                        let {startPosition, endPosition} = this.createLinkList(neuronData.nodes, viewName, i)

                        let neuronsService = this.injector.get<NeuronsService>(NeuronsService);
                        if (neuronsService.entireNeuronTracing) {
                            drawLine(startPosition, endPosition, color, canvas, 1);
                        } else {
                            const isWithinRange = this.sharedService.isBetween(startPosition.z, SelectedPosition.coordinates[this.views[viewName].axis] - 5, SelectedPosition.coordinates[this.views[viewName].axis] + 5);
                            // const lineWidth = isWithinRange ? 1 : 0.2;
                            const lineWidth = isWithinRange ? 1 : neuronsService.neuronsTracing.opacity;
                            drawLine(startPosition, endPosition, color, canvas, lineWidth);
                        }

                    }
                }
            }

        }
    }

    drawNeuronsGroupsOnImage(viewName: string, canvas) {
        // console.log("drawNeuronsGroupsOnImage");
        for (let i = 0; i < this.sceneItems.neuronsGroups.length; i++) {
            let currentGroup = this.sceneItems.neuronsGroups[i];
            if (currentGroup.visualizationOptions.show) {
                for (let j = 0; j < currentGroup.neuronsData.neuronsIDs.length; j++) {
                    let neuronID = currentGroup.neuronsData.neuronsIDs[j];
                    let neuron = currentGroup.neuronsData.neurons[neuronID];

                    if (neuron.selected) {
                        let neuronData = neuron.activeFile.data;
                        let color = neuron.visualizationOptions.color.hex;

                        // let somaPosition = neuron.getSoma().position[viewName];
                        let somaPosition = neuron.getSoma2DPosition(viewName);

                        if (somaPosition === null) {
                            return false;
                        }

                        drawNode(somaPosition, color, true, somaPosition.z === SelectedPosition.coordinates[this.views[viewName].axis], 6, true, canvas);

                        if (currentGroup.visualizationOptions.isOnlySoma === false) {
                            for (let i = 0; i < neuronData.links.length; i += 1) {
                                let startPosition = neuronData.links[i].parent.position[viewName];
                                let endPosition = neuronData.links[i].child.position[viewName];

                                drawLine(startPosition, endPosition, color, canvas, 1);
                            }
                        }
                    }
                }
            }
        }


        return canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height);
    }

    createCanvas(size) {

        //create a new canvas
        var newCanvas = document.createElement('canvas');
        var context = newCanvas.getContext('2d');

        //set dimensions
        newCanvas.width = size.width;
        newCanvas.height = size.height;

        //apply the old canvas to the new one
        // context.drawImage(oldCanvas, 0, 0);

        //return the new canvas
        return newCanvas;
    }

    //endregion

    //region ROIs

    addROITo2DScene(roi: EllipsoidROI, isUpdate = true) {
        this.sceneItems.rois.push(roi);

        if (isUpdate) {
            this.updateScene();
        }
    }

    addRectangularROITo2DScene(roi, isUpdate = true) {

        this.sceneItems.rectangularRois.push(roi);

        if (isUpdate) {
            this.updateScene();
        }
    }

    removeROIFrom2DScene(roi: EllipsoidROI, isUpdate = true) {
        let roiIndex = this.sceneItems.rois.indexOf(roi);
        this.sceneItems.rois.splice(roiIndex, 1);

        if (isUpdate) {
            this.updateScene();
        }
    }

    async updateROIsData() {
        for (let i = 0; i < this.sceneItems.rois.length; i++) {
            let roi = this.sceneItems.rois[i];

            if (this.activeLayout === this.layouts.orthogonal) {
                this.calculateROI2DPosition(roi,
                    this.views.dorsal,
                    this.layouts.orthogonal.dorsalImageToCanvasRatio,
                    this.layouts.orthogonal.dorsalCanvas.height);

                this.calculateROI2DRadius(roi, this.views.dorsal, this.layouts.orthogonal.dorsalImageToCanvasRatio);

                this.calculateROI2DPosition(roi,
                    this.views.sagittal,
                    this.layouts.orthogonal.sagittalImageToCanvasRatio,
                    this.layouts.orthogonal.sagittalCanvas.height);

                this.calculateROI2DRadius(roi, this.views.sagittal, this.layouts.orthogonal.sagittalImageToCanvasRatio);

                this.calculateROI2DPosition(roi,
                    this.views.coronal,
                    this.layouts.orthogonal.coronalImageToCanvasRatio,
                    this.layouts.orthogonal.coronalCanvas.height);

                this.calculateROI2DRadius(roi, this.views.coronal, this.layouts.orthogonal.coronalImageToCanvasRatio);

            } else if (this.activeLayout === this.layouts.single) {
                this.calculateROI2DPosition(roi,
                    this.activeView,
                    this.layouts.single.imageToCanvasRatio,
                    this.layouts.single.canvas.height);

                this.calculateROI2DRadius(roi, this.activeView, this.layouts.single.imageToCanvasRatio);

            } else if (this.activeLayout === this.layouts.split) {
                this.calculateROI2DPosition(roi,
                    this.activeView,
                    this.layouts.split.imageToCanvasRatio,
                    this.layouts.split.htmlElements.canvases[0].height);

                this.calculateROI2DRadius(roi, this.activeView, this.layouts.split.imageToCanvasRatio);
            }
        }
    }

    async updateRectangularROIsData() {
        for (let i = 0; i < this.sceneItems.rectangularRois.length; i++) {
            let roi = this.sceneItems.rectangularRois[i];

            if (this.activeLayout === this.layouts.orthogonal) {
                this.calculateRectangularROI2DPosition(roi,
                    this.views.dorsal,
                    this.layouts.orthogonal.dorsalImageToCanvasRatio,
                    this.layouts.orthogonal.dorsalCanvas.height);

                this.calculateRectangularROI2DPosition(roi,
                    this.views.sagittal,
                    this.layouts.orthogonal.sagittalImageToCanvasRatio,
                    this.layouts.orthogonal.sagittalCanvas.height);

                this.calculateRectangularROI2DPosition(roi,
                    this.views.coronal,
                    this.layouts.orthogonal.coronalImageToCanvasRatio,
                    this.layouts.orthogonal.coronalCanvas.height);

            }
        }
    }

    updateROI2DData() {
        this.updateScene()
    }

    calculateROI2DPosition(roi: EllipsoidROI, view: TwoDView, imageToCanvasRatio, canvasHeight) {
        roi.positions._2d[view.name] = view.convert3DPositionTo2DPosition(
            roi.backendData.position,
            imageToCanvasRatio,
            canvasHeight);
    }

    calculateRectangularROI2DPosition(roi: EllipsoidROI, view: TwoDView, imageToCanvasRatio, canvasHeight) {

        if (roi['autoGenerated']) {
            roi['viewsPositions']._2d[view.name]["bottomRight"] = view.convert3DPositionTo2DPosition(
                roi["bottomRight"],
                imageToCanvasRatio,
                canvasHeight);
        }
        roi['viewsPositions']._2d[view.name]["topLeft"] = view.convert3DPositionTo2DPosition(
            roi["topLeft"],
            imageToCanvasRatio,
            canvasHeight);

    }

    calculateROI2DRadius(roi: EllipsoidROI, view: TwoDView, imageToCanvasRatio) {

        let maxValueOnActiveAxis = roi.positions._2d[view.name].z + Math.floor(parseFloat(roi.mesh.scale[view.axis]));
        let radiusX = EllipsoidROI.getActualRadiusInLayer(roi.positions._2d[view.name].z,
            maxValueOnActiveAxis,
            SelectedPosition.coordinates[view.axis],
            roi.mesh.scale[view.getImageXAxis()]);
        roi.radii._2d[view.name].x = radiusX / imageToCanvasRatio.width;

        let radiusY = EllipsoidROI.getActualRadiusInLayer(roi.positions._2d[view.name].z,
            maxValueOnActiveAxis,
            SelectedPosition.coordinates[view.axis],
            roi.mesh.scale[view.getImageYAxis()]);
        roi.radii._2d[view.name].y = radiusY / imageToCanvasRatio.height;
    }

    drawROI(roi: EllipsoidROI, view: TwoDView, canvas) {

        let roiPosition = roi.positions._2d[view.name];

        let minValueOnActiveAxis = roiPosition.z - Math.floor(parseFloat(roi.mesh.scale[view.axis]));
        let maxValueOnActiveAxis = roiPosition.z + Math.floor(parseFloat(roi.mesh.scale[view.axis]));

        if (SelectedPosition.coordinates[view.axis] >= minValueOnActiveAxis &&
            SelectedPosition.coordinates[view.axis] <= maxValueOnActiveAxis) {

            drawEllipse(roiPosition,
                roi.radii._2d[view.name].x,
                roi.radii._2d[view.name].y,
                roi.color.hex, false, canvas, 1);
        }
    }


    drawRectangularROI(roi: RectangularROI, view: TwoDView, canvas) {

        let roiStartPosition = roi.viewsPositions._2d[view.name]["topLeft"];
        let roiEndPosition = roi.viewsPositions._2d[view.name]["bottomRight"];
        if (roi.autoGenerated) {
            // roi.shift(-Math.floor(roi.dimensions.width/2), -Math.floor(roi.dimensions.height/2));

            // let roiEndPosition = roi.viewsPositions._2d[view.name]["end"];
            // drawAutoGeneratedRectangular(roiStartPosition, roi.dimensions, "#00ff00", canvas, 1);
            drawRectangular(roiStartPosition, roiEndPosition, "#00ff00", canvas, 1);

        } else {
            drawRectangular(roiStartPosition, roi.dimensions, "#00ff00", canvas, 1);
        }

    }

    //endregion

    async updateScene() {
        if (this.activeLayout === this.layouts.orthogonal || (this.activeView && this.activeView.hasLabels)) {
            await this.updateNeuronsCoordinates();
            await this.updateROIsData();
            await this.updateRectangularROIsData();
        }
        await this.updateImages();
    }

    async updateImages() {
        // If the previous images were loaded, merged and drawn already
        this.isReadyToUpdate = false;

        let imagesToMerge = [];
        //brain
        if (this.sceneItems.images.nonSplit.length > 0) {
            imagesToMerge.push(this.sceneItems.images.nonSplit[0]);
        }

        // markers and fish
        for (let i = 0; i < this.sceneItems.images.split.length; i++) {
            imagesToMerge.push(...this.sceneItems.images.split[i]);
        }

        //regions
        imagesToMerge.push(...this.sceneItems.images.nonSplit.slice(-this.sceneItems.images.nonSplit.length - 1));

        if (imagesToMerge.length === 0 || imagesToMerge.every(element => element === null)) {
            this.isReadyToUpdate = true;
            this.activeLayout.clear();
            return;
        }

        if (this.activeLayout === this.layouts.orthogonal) {
            let dorsalLoadedImages = [];
            let dorsalImagesLoaders = this.drawingService.loadImages(imagesToMerge, this.views.dorsal, SelectedPosition.coordinates[this.views.dorsal.axis], dorsalLoadedImages);
            let dorsalMergedImage = await this.drawingService.mergeImages(dorsalImagesLoaders, dorsalLoadedImages);

            let sagittalLoadedImages = [];
            let sagittalImagesLoaders = this.drawingService.loadImages(imagesToMerge, this.views.sagittal, SelectedPosition.coordinates[this.views.sagittal.axis], sagittalLoadedImages);
            let sagittalMergedImage = await this.drawingService.mergeImages(sagittalImagesLoaders, sagittalLoadedImages);

            let coronalLoadedImages = [];
            let coronalImagesLoaders = this.drawingService.loadImages(imagesToMerge, this.views.coronal, SelectedPosition.coordinates[this.views.coronal.axis], coronalLoadedImages);
            let coronalMergedImage = await this.drawingService.mergeImages(coronalImagesLoaders, coronalLoadedImages);

            await this.drawingService.drawImage(dorsalMergedImage, this.layouts.orthogonal.dorsalCanvas);
            await this.drawingService.drawImage(sagittalMergedImage, this.layouts.orthogonal.sagittalCanvas);
            await this.drawingService.drawImage(coronalMergedImage, this.layouts.orthogonal.coronalCanvas);

            let xLabel = this.views.dorsal.getImageXAxis() + ' = ' + SelectedPosition.coordinates[this.views.dorsal.getImageXAxis()].toString();
            let yLabel = this.views.dorsal.getImageYAxis() + ' = ' + SelectedPosition.coordinates[this.views.dorsal.getImageYAxis()].toString();
            let layerLabel = this.views.dorsal.getImageZAxis() + ' = ' + SelectedPosition.coordinates[this.views.dorsal.getImageZAxis()].toString();

            SelectedPosition.draw(this.layouts.orthogonal.dorsalCanvas,
                this.views.dorsal,
                xLabel, yLabel, layerLabel,
                this.layouts.orthogonal.dorsalImageToCanvasRatio);

            ScaleBar.draw(this.layouts.orthogonal.dorsalCanvas,
                this.views.dorsal,
                this.layouts.orthogonal.dorsalImageToCanvasRatio);

            xLabel = this.views.sagittal.getImageXAxis() + ' = ' + SelectedPosition.coordinates[this.views.sagittal.getImageXAxis()].toString();
            yLabel = this.views.sagittal.getImageYAxis() + ' = ' + SelectedPosition.coordinates[this.views.sagittal.getImageYAxis()].toString();
            layerLabel = this.views.sagittal.getImageZAxis() + ' = ' + SelectedPosition.coordinates[this.views.sagittal.getImageZAxis()].toString();

            SelectedPosition.draw(this.layouts.orthogonal.sagittalCanvas,
                this.views.sagittal,
                xLabel, yLabel, layerLabel,
                this.layouts.orthogonal.sagittalImageToCanvasRatio);

            ScaleBar.draw(this.layouts.orthogonal.sagittalCanvas,
                this.views.sagittal,
                this.layouts.orthogonal.sagittalImageToCanvasRatio);


            xLabel = this.views.coronal.getImageXAxis() + ' = ' + SelectedPosition.coordinates[this.views.coronal.getImageXAxis()].toString();
            yLabel = this.views.coronal.getImageYAxis() + ' = ' + SelectedPosition.coordinates[this.views.coronal.getImageYAxis()].toString();
            layerLabel = this.views.coronal.getImageZAxis() + ' = ' + SelectedPosition.coordinates[this.views.coronal.getImageZAxis()].toString();

            SelectedPosition.draw(this.layouts.orthogonal.coronalCanvas,
                this.views.coronal,
                xLabel, yLabel, layerLabel,
                this.layouts.orthogonal.coronalImageToCanvasRatio);

            ScaleBar.draw(this.layouts.orthogonal.coronalCanvas,
                this.views.coronal,
                this.layouts.orthogonal.coronalImageToCanvasRatio);

            for (let i = 0; i < this.sceneItems.neuronsGroups.length; i++) {
                this.drawNeuronsGroup(this.sceneItems.neuronsGroups[i], this.views.dorsal.name, this.layouts.orthogonal.dorsalCanvas);
                this.drawNeuronsGroup(this.sceneItems.neuronsGroups[i], this.views.sagittal.name, this.layouts.orthogonal.sagittalCanvas);
                this.drawNeuronsGroup(this.sceneItems.neuronsGroups[i], this.views.coronal.name, this.layouts.orthogonal.coronalCanvas);
            }

            for (let i = 0; i < this.sceneItems.rois.length; i++) {
                this.drawROI(this.sceneItems.rois[i], this.views.dorsal, this.layouts.orthogonal.dorsalCanvas);
                this.drawROI(this.sceneItems.rois[i], this.views.sagittal, this.layouts.orthogonal.sagittalCanvas);
                this.drawROI(this.sceneItems.rois[i], this.views.coronal, this.layouts.orthogonal.coronalCanvas);
            }

            // ************************** problem is here
            for (let i = 0; i < this.sceneItems.rectangularRois.length; i++) {
                this.drawRectangularROI(this.sceneItems.rectangularRois[i], this.views.dorsal, this.layouts.orthogonal.dorsalCanvas);
                this.drawRectangularROI(this.sceneItems.rectangularRois[i], this.views.sagittal, this.layouts.orthogonal.sagittalCanvas);
                this.drawRectangularROI(this.sceneItems.rectangularRois[i], this.views.coronal, this.layouts.orthogonal.coronalCanvas);
            }


        } else if (this.activeLayout === this.layouts.single) {
            let loadedImages = [];

            let imagesLoaders = this.drawingService.loadImages(imagesToMerge, this.activeView, SelectedPosition.coordinates[this.activeView.axis], loadedImages);
            let mergedImage = await this.drawingService.mergeImages(imagesLoaders, loadedImages);


            await this.drawingService.drawImage(mergedImage, this.layouts.single.canvas);
            ScaleBar.draw(this.layouts.single.canvas,
                this.activeView,
                this.layouts.single.imageToCanvasRatio);

            if (this.activeView.hasLabels) {
                let xLabel = this.activeView.getImageXAxis() + ' = ' + SelectedPosition.coordinates[this.activeView.getImageXAxis()].toString();
                let yLabel = this.activeView.getImageYAxis() + ' = ' + SelectedPosition.coordinates[this.activeView.getImageYAxis()].toString();
                let layerLabel = this.activeView.getImageZAxis() + ' = ' + SelectedPosition.coordinates[this.activeView.getImageZAxis()].toString();

                SelectedPosition.draw(this.layouts.single.canvas,
                    this.activeView,
                    xLabel, yLabel, layerLabel,
                    this.layouts.single.imageToCanvasRatio);

                for (let i = 0; i < this.sceneItems.neuronsGroups.length; i++) {
                    this.drawNeuronsGroup(this.sceneItems.neuronsGroups[i], this.activeView.name, this.layouts.single.canvas);
                }


                for (let i = 0; i < this.sceneItems.rois.length; i++) {
                    this.drawROI(this.sceneItems.rois[i], this.activeView, this.layouts.single.canvas);
                }
            }

        } else if (this.activeLayout === this.layouts.split) {

            let nonSplitLoadedImages = [];
            let nonSplitImagesLoaders = this.drawingService.loadImages(this.sceneItems.images.nonSplit, this.activeView, SelectedPosition.coordinates[this.activeView.axis], nonSplitLoadedImages);
            let nonSplitMergedImageData = await this.drawingService.mergeImages(nonSplitImagesLoaders, nonSplitLoadedImages);

            let splitImages = [];
            for (let i = 0; i < this.sceneItems.images.split.length; i++) {
                let loadedImages = []
                let imagesLoaders = this.drawingService.loadImages(this.sceneItems.images.split[i], this.activeView, SelectedPosition.coordinates[this.activeView.axis], loadedImages);
                let mergedImage = await this.drawingService.mergeImages(imagesLoaders, loadedImages);
                splitImages.push(mergedImage);
            }
            // let splitLoadedImages = [];
            // let splitImagesLoaders = this.drawingService.loadImages(this.sceneItems.images.split, this.activeView, SelectedPosition.coordinates[this.activeView.axis], splitLoadedImages);

            // let splitMergedImagesData = await this.drawingService.mergeOneImageWithEachImageFromArray(nonSplitMergedImageData, splitImagesLoaders, splitLoadedImages);
            let splitMergedImagesData = await this.drawingService.mergeOneImagesDataWithEachImageFromArray(nonSplitMergedImageData, splitImages);

            for (let i = 0; i < this.sceneItems.images.split.length; i++) {
                await this.drawingService.drawImage(splitMergedImagesData[i], this.activeLayout.htmlElements.canvases[i]);
                // ScaleBar.draw(this.activeLayout.htmlElements.canvases[i],
                //     this.views.movieY,
                //     this.layouts.single.imageToCanvasRatio);
                if (this.activeView.hasLabels) {
                    let xLabel = this.activeView.getImageXAxis() + ' = ' + SelectedPosition.coordinates[this.activeView.getImageXAxis()].toString();
                    let yLabel = this.activeView.getImageYAxis() + ' = ' + SelectedPosition.coordinates[this.activeView.getImageYAxis()].toString();
                    let layerLabel = this.activeView.getImageZAxis() + ' = ' + SelectedPosition.coordinates[this.activeView.getImageZAxis()].toString();
                    SelectedPosition.draw(this.activeLayout.htmlElements.canvases[i],
                        this.activeView,
                        xLabel, yLabel, layerLabel,
                        this.activeLayout.imagesToCanvasesRatios[0]);

                    for (let j = 0; j < this.sceneItems.neuronsGroups.length; j++) {
                        this.drawNeuronsGroup(this.sceneItems.neuronsGroups[j], this.activeView.name, this.activeLayout.htmlElements.canvases[i]);
                    }

                    for (let j = 0; j < this.sceneItems.rois.length; j++) {
                        this.drawROI(this.sceneItems.rois[j], this.activeView, this.activeLayout.htmlElements.canvases[i]);
                    }
                }
            }

        }
        this.isReadyToUpdate = true;
        // this.spinner.hide();
    }

    activeViewChnaged(newActiveView, newActiveLayout, chosenView) {
        this.chosenView = chosenView;
        this.spinner.show();
        if (this.activeView instanceof MovieView) {
            if (!(newActiveView instanceof MovieView)) {
                SelectedPosition.initializeOrthogonalViews();
            } else {
                SelectedPosition.initializeMovieView(newActiveView);
            }
        } else if (newActiveView instanceof MovieView) {
            SelectedPosition.initializeMovieView(newActiveView);
        }
        this.activeView = newActiveView;
        this.clearNeurons2DData();
        this.activateLayout(newActiveLayout);
    }

    onActiveViewChange(newActiveView, newActiveLayout, chosenView) {
        if (chosenView.includes("Movie")) {
            let markerService = this.injector.get<MarkersService>(MarkersService);
            let selectedFishCount = markerService.selectedFish.length;
            if (selectedFishCount) {
                if (confirm("Movie view DOES NOT support visualizing individual fish. All your selected individual fish will be unselected. Are you sure you would like to continue? ")) {
                    for (let m = 0; m < markerService.markersData.selectedMarkersList.length; m++) {
                        if ((markerService.markersData.selectedMarkersList[m].has_fish) &&
                            (markerService.markersData.selectedMarkersList[m].selectedFish != undefined ||
                                markerService.markersData.selectedMarkersList[m].selectedFish != null)) {
                            for (let f = 0; f < markerService.markersData.selectedMarkersList[m].selectedFish.length; f++) {
                                markerService.deselectFish(markerService.markersData.selectedMarkersList[m].selectedFish[f], markerService.markersData.selectedMarkersList[m], true)

                            }
                        }
                    }
                    this.activeViewChnaged(newActiveView, newActiveLayout, chosenView);
                }
            } else {
                this.activeViewChnaged(newActiveView, newActiveLayout, chosenView);
            }
        } else {
            this.activeViewChnaged(newActiveView, newActiveLayout, chosenView);
        }
    }

    onActiveViewClick(chosenViewKey) {
        let layoutEventsService = this.injector.get<LayoutEventsService>(LayoutEventsService);
        layoutEventsService.videoPlayControls.next = false;
        layoutEventsService.videoPlayControls.previous = false;
        clearInterval(layoutEventsService.intervalId);

        if (this.chosenViewLabel[chosenViewKey] == this.chosenViewLabel[0]) {
            this.currentChosenViewKey = 0;
            this.onActiveViewChange(null, this.layouts.orthogonal, this.chosenViewLabel[0]);
        } else if (this.chosenViewLabel[chosenViewKey] == this.chosenViewLabel[1]) {
            this.currentChosenViewKey = 1;
            this.onActiveViewChange(this.views.dorsal, this.layouts.single, this.chosenViewLabel[1]);
        } else if (this.chosenViewLabel[chosenViewKey] == this.chosenViewLabel[2]) {
            this.currentChosenViewKey = 2;
            this.onActiveViewChange(this.views.sagittal, this.layouts.single, this.chosenViewLabel[2]);
        } else if (this.chosenViewLabel[chosenViewKey] == this.chosenViewLabel[3]) {
            this.currentChosenViewKey = 3;
            this.onActiveViewChange(this.views.coronal, this.layouts.single, this.chosenViewLabel[3]);
        } else if (this.chosenViewLabel[chosenViewKey] == this.chosenViewLabel[4]) {
            this.currentChosenViewKey = 4;
            this.onActiveViewChange(this.views.movieX, this.layouts.single, this.chosenViewLabel[4]);
        } else if (this.chosenViewLabel[chosenViewKey] == this.chosenViewLabel[5]) {
            this.currentChosenViewKey = 5;
            this.onActiveViewChange(this.views.movieY, this.layouts.single, this.chosenViewLabel[5]);
        } else if (this.chosenViewLabel[chosenViewKey] == this.chosenViewLabel[6]) {
            this.currentChosenViewKey = 6;
            this.onActiveViewChange(this.views.dorsal, this.layouts.split, this.chosenViewLabel[6]);
        } else if (this.chosenViewLabel[chosenViewKey] == this.chosenViewLabel[7]) {
            this.currentChosenViewKey = 7;
            this.onActiveViewChange(this.views.sagittal, this.layouts.split, this.chosenViewLabel[7]);
        } else if (this.chosenViewLabel[chosenViewKey] == this.chosenViewLabel[8]) {
            this.currentChosenViewKey = 8;
            this.onActiveViewChange(this.views.coronal, this.layouts.split, this.chosenViewLabel[8]);
        } else if (this.chosenViewLabel[chosenViewKey] == this.chosenViewLabel[9]) {
            this.currentChosenViewKey = 9;
            this.onActiveViewChange(this.views.movieX, this.layouts.split, this.chosenViewLabel[9]);
        } else {
            this.currentChosenViewKey = 10;
            this.onActiveViewChange(this.views.movieY, this.layouts.split, this.chosenViewLabel[10]);
        }
    }


    clearNeurons2DData() {
        this.neuronsImage = null;
        for (let i = 0; i < this.sceneItems.neuronsGroups.length; i++) {
            let neuronsGroup = this.sceneItems.neuronsGroups[i];
            for (let j = 0; j < neuronsGroup.neuronsData.neuronsIDs.length; j++) {
                let neuronID = neuronsGroup.neuronsData.neuronsIDs[j];
                let neuron = neuronsGroup.neuronsData.neurons[neuronID];
                neuron.clear2DData();
            }
        }
    }

    onResize() {
        this.clearNeurons2DData();
        this.activateLayout(this.activeLayout);
    }
}
